const fields = { Name: 'name', Company: 'company', Tel: 'tel', Email: 'email', CountryCode: 'countryCode', State: 'state', City: 'city', District: 'district', Addr: 'address', Addr2: 'address2', Zip: 'zip' }

export function orderContactDraft (payload, type, userId) {
  const prefix = type === 'SENDER' ? 'sd' : 're'
  const draft = { userId, contactType: type, isDefault: false }
  for (const [suffix, field] of Object.entries(fields)) draft[field] = String(payload[prefix + suffix] || '').trim()
  return draft
}

export function completeOrderContact (draft) {
  return ['name', 'tel', 'countryCode', 'address'].every(field => draft[field])
}

export function sameOrderContact (left, right) {
  return left.contactType === right.contactType && Object.values(fields).every(field => String(left[field] || '').trim() === String(right[field] || '').trim())
}
